// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"eca34f88","213":"15019ed9","667":"a6fc60b4"}[chunkId] + ".chunk.js";
};